export interface AppItem {
  sysCode: string;
  projectName: string;
  sysName: string;
  localHost: string;
  baseDir: string;
  path: string;
  defaultPagePath: string;
  component: string;
  debug: boolean;
  isExpand: boolean;
}

export const APP_LIST: Array<AppItem> = [
  {
    sysCode: "F2E-harbour-web",
    projectName: "F2E-harbour-web",
    sysName: "中台",
    localHost: "http://local.fat.driverglobe.com:8060",
    debug: true,
    baseDir: "/web/F2E-harbour-web",
    isExpand: true,
    path: "/child-container/yzs-f2e",
    component: "/ChildContainer/yzs-f2e",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "harbour-container-pc",
    sysName: "鸭嘴兽新中台",
    projectName: "harbour-container-pc",
    localHost: "http://local.fat.driverglobe.com:8070",
    debug: false,
    baseDir: "/web/harbour-container-pc",
    isExpand: true,
    path: "/child-container/container-pc",
    component: "/ChildContainer/container-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "contract-management-pc",
    sysName: "合同管理",
    projectName: "/contract-management-pc",
    localHost: "http://local.fat.driverglobe.com:5173",
    debug: false,
    baseDir: "/web/contract-management-pc",
    isExpand: true,
    path: "/child-container/contract-management-pc",
    component: "/ChildContainer/contract-management-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "customer-message-pc",
    sysName: "智能客服",
    projectName: "customer-message-pc",
    localHost: "http://local.fat.driverglobe.com:8050",
    debug: false,
    baseDir: "/web/customer-message-pc",
    isExpand: true,
    path: "/child-container/customer-message-pc",
    component: "/ChildContainer/customer-message-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "base-biz-data-admin-pc",
    sysName: "国际化数据",
    projectName: "base-biz-data-admin-pc",
    localHost: "http://local.fat.driverglobe.com:8077",
    debug: false,
    baseDir: "/web/base-biz-data-admin-pc",
    isExpand: true,
    path: "/child-container/base-biz-data-admin-pc",
    component: "/ChildContainer/base-biz-data-admin-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "ftboss-pc",
    sysName: "人车运力",
    projectName: "ftboss-pc",
    localHost: "http://local.fat.driverglobe.com:8081",
    debug: false,
    baseDir: "/web/ftboss-pc",
    isExpand: true,
    path: "/child-container/ftboss-pc",
    component: "/ChildContainer/ftboss-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "ecommerce-client",
    sysName: "商城",
    projectName: "ecommerce-client",
    localHost: "http://local.fat.driverglobe.com:8888",
    debug: false,
    baseDir: "/web/ecommerce-client",
    isExpand: true,
    path: "/child-container/ecommerce-client",
    component: "/ChildContainer/ecommerce-client",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "ecommerce-child-client",
    sysName: "商城",
    projectName: "ecommerce-child-client",
    localHost: "http://local.fat.driverglobe.com:8889",
    debug: false,
    baseDir: "/web/ecommerce-child-client",
    isExpand: true,
    path: "/child-container/ecommerce-child-client",
    component: "/ChildContainer/ecommerce-child-client",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "accounting-center-web-pc",
    sysName: "商财系统",
    projectName: "accounting-center-web-pc",
    localHost: "http://local.fat.driverglobe.com:7110",
    debug: false,
    baseDir: "/web/accounting-center-web-pc",
    isExpand: true,
    path: "/child-container/accounting-center-web-pc",
    component: "/ChildContainer/accounting-center-web-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "iam-admin-pc",
    sysName: "用户中心",
    projectName: "iam-admin-pc",
    localHost: "http://local.fat.driverglobe.com:8890",
    debug: true,
    baseDir: "/web/iam-admin-pc",
    isExpand: true,
    path: "/child-container/iam-admin-pc",
    component: "/ChildContainer/iam-admin-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "duckbill-ppc-web",
    sysName: "价格中心",
    projectName: "duckbill-ppc-web",
    localHost: "http://local.fat.driverglobe.com:8000",
    debug: true,
    baseDir: "/web/duckbill-ppc-web",
    isExpand: true,
    path: "/child-container/duckbill-ppc-web",
    component: "/ChildContainer/duckbill-ppc-web",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "ttp-web-pc",
    sysName: "车联网用户端",
    projectName: "ttp-web-pc",
    localHost: "http://local.fat.driverglobe.com:8891",
    debug: true,
    baseDir: "/web/ttp-web-pc",
    isExpand: true,
    path: "/child-container/ttp-web-pc",
    component: "/ChildContainer/ttp-web-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "ttp-admin-pc",
    sysName: "车联网管理端",
    projectName: "ttp-admin-pc",
    localHost: "http://local.fat.driverglobe.com:8892",
    debug: true,
    baseDir: "/web/ttp-admin-pc",
    isExpand: true,
    path: "/child-container/ttp-admin-pc",
    component: "/ChildContainer/ttp-admin-pc",
    defaultPagePath: "/control-center",
  },
  {
    sysCode: "call-center-admin-pc",
    sysName: "鸭嘴兽呼叫中心",
    projectName: "call-center-admin-pc",
    localHost: "http://local.fat.driverglobe.com:8893",
    debug: true,
    baseDir: "/web/call-center-admin-pc",
    isExpand: true,
    path: "/child-container/call-center-admin-pc",
    component: "/ChildContainer/call-center-admin-pc",
    defaultPagePath: "/control-center",
  },
];
